import * as React from "react";

export default function ImageSection({ image, imageAlt, children }: { image: string; imageAlt: string; children?: React.ReactNode }) {
  return (
    <>
      {children && <div>{children}</div>}
      <div className="tw-mt-16 tw-flow-root">
        <div className="tw--m-2 tw-rounded-xl tw-bg-brand_scale-50/10 tw-p-2 tw-ring-1 tw-ring-inset tw-ring-grey_scale-900/10 lg:tw--m-4 lg:tw-rounded-2xl lg:tw-p-4">
          <img
            alt={imageAlt}
            src={`../../../${image}`}
            width={2432}
            height={1442}
            className="tw-rounded-md tw-shadow-2xl tw-ring-1 tw-ring-grey_scale-900/10"
          />
        </div>
      </div>
    </>
  );
}
